import { styled } from '@lessonup/ui-components';

export const PageWrapper = styled.div`
  max-width: 500px;
`;
